import { Check, XCircle } from "lucide-react";
import { Card } from "@/components/ui/card";

interface TaskData {
  id: string;
  type: string;
  description: string;
  status: string;
}

interface TaskUpdatedWidgetProps {
  data: TaskData;
}

export function TaskUpdatedWidget({ data }: TaskUpdatedWidgetProps) {
  if (!data) return null;
  const isDone = data.status === "done";

  return (
    <Card
      variant={isDone ? "success" : "default"}
      padding="sm"
      className="max-w-md animate-slide-up"
    >
      <div className="flex items-center gap-3">
        {isDone ? (
          <Check size={16} className="text-daydra-success shrink-0" />
        ) : (
          <XCircle size={16} className="text-daydra-muted shrink-0" />
        )}
        <div className="flex-1 min-w-0">
          <p className="text-sm text-daydra-text">
            <span className={isDone ? "line-through text-daydra-dim" : ""}>
              {data.description}
            </span>
          </p>
          <p className="text-2xs text-daydra-muted mt-0.5">
            Marked as {data.status}
          </p>
        </div>
      </div>
    </Card>
  );
}
